























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ProjectsLists extends Vue {
    @Prop({ default: 20 }) perPage!: number;

    @Prop({ default: false }) showSvg!: boolean;

    loading = false;

    projects: Estate[] = [];

    params: SweepbrightParams = { per_page: 20, page: 1, is_project: false, sort: "created_at,desc", min: 0 };

    mounted() {
        this.getProjects();
    }

    private getProjects() {
        this.params.per_page = this.perPage;

        this.loading = true;
        // @ts-ignore
        axios
            .get("/api/projects", { params: { ...this.params } })
            .then((response: any) => (this.projects = response.data.data))
            .finally(() => (this.loading = false));
    }
}
